import { registerGenerator } from '@/utils/generate';
import { KbnConst } from '@/utils/kbn';

import { ContentBase } from './content_base';

export class ContentPurchaseCountDeclareModel extends ContentBase {
  typeKbn = KbnConst.CONTENT_TYPE_KBN_PURCHASE_COUNT_DECLARE;

  constructor(init?: Partial<ContentPurchaseCountDeclareModel>) {
    super();
    Object.assign(this, init);
  }
}

registerGenerator(
  ContentPurchaseCountDeclareModel,
  () => new ContentPurchaseCountDeclareModel(),
);
